// extracted by mini-css-extract-plugin
export default {"wrapper":"Seeds_wrapper__6BSjA"};